import { Capacitor } from "@capacitor/core";
import "../style.css";
import { GameApp } from "./app/GameApp";
import { AdService } from "./services/AdService";
import { AnalyticsService } from "./services/AnalyticsService";
import { ConsentService } from "./services/ConsentService";
import { ConsentBanner } from "./presentation/ConsentBanner";
import { PwaService } from "./platform/PwaService";
import { NativePlatformService } from "./platform/NativePlatformService";
import { buildRuntimeAdConfig } from "./config/releaseConfig";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("Missing app root");

new PwaService().register();
void new NativePlatformService().initialize();

const consent = new ConsentService(localStorage);
const consentState = consent.initialize();
const nativePlatform = Capacitor.isNativePlatform();
const ads = new AdService(buildRuntimeAdConfig(import.meta.env, nativePlatform));
const analytics = new AnalyticsService();
const consentBanner = nativePlatform ? undefined : new ConsentBanner(consent);

void ads.initialize(consentState).catch(() => ads.hideAll());
analytics.initialize(consentState);
consent.subscribe((state) => {
  void ads.initialize(state).catch(() => ads.hideAll());
  if (state.categories.advertising !== "granted") ads.hideAll();
  analytics.initialize(state);
});

new GameApp(root, ads, () => consentBanner?.open(), analytics);

// The native app IS the whole product on a device - there's no portfolio
// site to return to, so this action only makes sense on web.
if (nativePlatform) {
  document.querySelectorAll<HTMLElement>("#back-to-games, #result-back-to-games, #pause-back-to-games").forEach(el => {
    el.hidden = true;
  });
}
